import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import {format} from "date-fns";
import Dt_Cal from "../../lib/ui/dt_cal";
import * as utils from "../../assets/utils";
import Td_Sel from "../../lib/ui/td_sel";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class TH_Trs extends React.Component {
  constructor(props, context) {
    super(props);

      this.dt_fd = React.createRef();
      this.dt_td = React.createRef();

      this.store = props.store;
      this.ta = props.store.ta;

    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.tra = [];
    this.state.kro = {};
    this.state.aa = [];
      this.state.wnds = {};
      this.state.sortid = "";
      this.state.sortdir = 1;

      if(this.ta && this.ta.base) {
          this.state.fdat = this.ta.base.fdat;
          this.state.tdat = this.ta.base.tdat;
      }

      this.selitems = [
          {fkn: 'open', text: 'ÖPPNA'},
          {fkn: 'prn', text: 'SKRIV UT'}
      ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.trs();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        css.overflow = "auto";
        return css;
    }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) {
            if(this.state.sortdir) css.color = "#800";
            else css.color = "#080";
        }
        return css;
    }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
    dt_fdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ fdat: dts });
    }
    dt_tdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ tdat: dts });
    }
    oneday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_td.current.updateDt(this.state.fdat);
    }
    addday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateAdd();
        this.dt_td.current.updateAdd();
    }
    subday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateSub();
        this.dt_td.current.updateSub();
    }

  kund_open(row) {
      var self = this;
  }
  kund_edit(row) {
      var self = this;
      //alert(JSON.stringify(row.krr00));
        this.setState({edit: 1, kro: row});
  }
  fkn_close() {
    this.setState({edit: false });
    //this.props.history.push("cas");
    //this.login_srv(uid, pwd);
  }

  trs() {
    var self = this;
    var prm = {};
    prm.req = "ta.ta_th.trs_ft";
      prm.fdat = this.state.fdat;
      prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({tra: ret.rca }, function() {
            self.syncTb("trsTable");
        });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var tha = self.state.tha;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(typ) {
            if(sortdir) tha.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
            else tha.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        }
        self.setState({ tha: tha, sortid: typ, sortdir: sortdir });
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row flex-space-between">
        <div className="label_h03">TRANSAKTIONER</div>
        <div className="flex"></div>
        <div className="flex-row">
            <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
            <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
            <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
            <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
            <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
        </div>
        <div className="flex"></div>
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.trs() } aria-label="System" >
            Visa
        </button>
    </div>
        <div className="divider"></div>

        <div id="trsTable" className="web-col">
            <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                    <th style={ this.th_style("anstnummer") } onClick={() => this.tb_sort("anstnummer") }>Anstnr <i className={ this.th_icon("anstnummer") }></i></th>
                    <th style={ this.th_style("namn") } onClick={() => this.tb_sort("namn") }>Namn <i className={ this.th_icon("namn") }></i></th>
                    <th style={ this.th_style("tidpunkt") } onClick={() => this.tb_sort("tidpunkt") }>Tdpunkt <i className={ this.th_icon("tidpunkt") }></i></th>
                    <th style={ this.th_style("avdelning") } onClick={() => this.tb_sort("avdelning") }>Avdelning <i className={ this.th_icon("avdelning") }></i></th>
                    <th style={ this.th_style("andelning") } onClick={() => this.tb_sort("andelning") }>Andelning <i className={ this.th_icon("andelning") }></i></th>
                    <th style={ this.th_style("schemanr") } onClick={() => this.tb_sort("schemanr") }>Schemanr <i className={ this.th_icon("schemanr") }></i></th>
                    <th style={ this.th_style("inslagentid") } onClick={() => this.tb_sort("inslagentid") }>Inslagentid <i className={ this.th_icon("inslagentid") }></i></th>
                    <th style={ this.th_style("inslaget") } onClick={() => this.tb_sort("inslaget") }>Inslaget <i className={ this.th_icon("inslaget") }></i></th>
                    <th style={ this.th_style("funktion") } onClick={() => this.tb_sort("funktion") }>Funktion <i className={ this.th_icon("funktion") }></i></th>
                    <th style={ this.th_style("terminal") } onClick={() => this.tb_sort("terminal") }>Terminal <i className={ this.th_icon("terminal") }></i></th>
                    <th style={ this.th_style("klocka") } onClick={() => this.tb_sort("klocka") }>Klocka <i className={ this.th_icon("klocka") }></i></th>
                    <th></th>
                </tr>
                </thead>
            </table>
            <div className="tb-cdi" style={ this.tb_style() }>
                <table className="table table-bordered table-hover tb">
                    <tbody>
                    { this.state.tra.map((row, key) =>
                        <tr key={key} onDoubleClick={() => this.ee_edit(row) }>
                            <td>{ row.anstnummer }</td>
                            <td>{ utils.toLang( row.text ) }</td>
                            <td>{ row.tidpunkt }</td>
                            <td>{ row.avdelning }</td>
                            <td>{ row.andelning }</td>
                            <td>{ row.schemanr }</td>
                            <td>{ row.inslagentid }</td>
                            <td>{ row.inslaget }</td>
                            <td>{ row.funktion }</td>
                            <td>{ row.terminal }</td>
                            <td>{ row.klocka }</td>
                            <td>
                                <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
   </div>
  );
    }
}
export default TH_Trs;
